import { Box, Typography } from "@braintrust/braintrust-ui-components";
import { pluralize } from "@js/utils";

export const JobOpeningResultsCount = ({
  openingsCount,
}: {
  openingsCount: number;
}) => {
  if (!openingsCount) {
    return null;
  }
  const label = `job opening${pluralize(openingsCount, { zeroPlural: true })}`;

  return (
    <Box sx={{ mr: 1 }}>
      <Typography fontWeight={500} component="span" sx={{ fontSize: "small" }}>
        {openingsCount.toLocaleString("en-US")}{" "}
      </Typography>
      <Typography component="span" sx={{ fontSize: "small" }}>
        {label}
      </Typography>
    </Box>
  );
};
